import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-section-top',
    templateUrl: './section-top.component.html',
    styleUrls: ['./section-top.component.scss'],
    standalone: false
})
export class SectionTopComponent implements OnInit {

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
  }

  navigate(location: string): void {
    this.router.navigate([location]);
  }
}
